import { apikoApi } from './utils';
import { isUnauthorizedError, getErrorMessage } from '../utils';

/**
 * login :: Object -> Promise Error _
 */

export const login = ({ email, password }) =>
  apikoApi({
    method: 'POST',
    url: '/auth/login',
    data: { email, password },
  })
    .then(({ data: { token, userId } }) => {
      localStorage.setItem('token', token);
      localStorage.setItem('userId', userId);
    })
    .catch((error) => {
      const errorMessage = isUnauthorizedError(error)
        ? 'Invalid email or password'
        : 'Enter your email and password';
      return Promise.reject(new Error(errorMessage));
    });

export const restorePassword = ({ password, token }) =>
  apikoApi({
    method: 'POST',
    url: '/auth/restore-password',
    data: { token, password },
  }).catch(getErrorMessage);

export const forgotPassword = ({ email }) =>
  apikoApi({
    method: 'POST',
    url: '/auth/request-restore-link',
    data: { email },
  }).catch(getErrorMessage);

export const connectGoogleAuth = (googleId, userId) =>
  apikoApi({
    method: 'PATCH',
    url: '/auth/google/connectAuth',
    data: { googleId, userId },
  }).catch(getErrorMessage);

export const disconnectGoogleAuth = userId =>
  apikoApi({
    method: 'PATCH',
    url: '/auth/google/disconnectAuth',
    data: { userId },
  }).catch(getErrorMessage);

export const connectGmail = (accessToken, refreshToken, userId) =>
  apikoApi({
    method: 'PATCH',
    url: '/auth/google/connectGmail',
    data: { accessToken, refreshToken, userId },
  }).catch(getErrorMessage);

export const disconnectGmail = userId =>
  apikoApi({
    method: 'PATCH',
    url: '/auth/google/disconnectGmail',
    data: { userId },
  }).catch(getErrorMessage);




// WEBPACK FOOTER //
// ./src/api/apiko-api/auth.js